import { useEffect, useMemo, useState } from 'react';
import { loadConfig, type AppConfig } from '../config';
import { createApiClient } from '../api/client';
import { createClientsApi } from '../api/clients';
import { createUsageApi } from '../api/usage';
import { useAuth } from '../auth/useAuth';

export function useApiClients() {
  const { getValidAccessToken } = useAuth();
  const [config, setConfig] = useState<AppConfig | null>(null);
  useEffect(() => { loadConfig().then(setConfig); }, []);

  return useMemo(() => {
    if (!config) return null;
    const client = createApiClient(getValidAccessToken);
    return {
      clients: createClientsApi(client, config.clientsUrl),
      usage: createUsageApi(client, config.usageUrl),
      postUrl: config.postUrl,
      getUrl: config.getUrl,
    };
  }, [config, getValidAccessToken]);
}